module.exports = __webpack_public_path__ + "img/report_refered_request.761de778.png";